import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIntercom } from "react-use-intercom";
import { ReactComponent as ChatSVG } from "../../../../../../../../images/svg/subscriptions/chat.svg";

const SubscriptionsSupport = () => {
	const { show } = useIntercom();
	const { t } = useTranslation();

	const launchIntercom = () => {
		show();
	};

	return (
		<Card className="subscription-info-card">
			<Card.Body>
				<div className="d-flex align-items-center mb-3">
					<div className="subscription-card-icon-box me-2">
						<ChatSVG />
					</div>
					<h5 className="mb-0">Support</h5>
				</div>
				<div>{t("modules.subscription.field.help.title")}</div>
				<div className={"card-body-footer"}>
					<a href={"#"} role={"button"} onClick={launchIntercom}>
						{t("modules.subscription.action.contact_with_us.title")}
					</a>
				</div>
			</Card.Body>
		</Card>
	);
};
export default SubscriptionsSupport;
